import { getActiveExperienceVariant, type ExperienceVariant } from '@/lib/experienceLaunch';
import { useEffect, useState } from 'react';

export function useActiveExperienceVariant(): ExperienceVariant | null {
  const [variant, setVariant] = useState<ExperienceVariant | null>(() => getActiveExperienceVariant());

  useEffect(() => {
    const sync = () => setVariant(getActiveExperienceVariant());
    sync();

    const intervalId = window.setInterval(sync, 60_000);
    return () => window.clearInterval(intervalId);
  }, []);

  return variant;
}
